import { type PropsWithOptionalTestID } from "@boi/components-core";

import * as S from "./AccordionGroup.styled";
import { Accordion, type AccordionProps } from "../Accordion";

type NestedAccordionItem = Omit<AccordionProps, "variant">;

type AccordionItem = Omit<NestedAccordionItem, "content"> & {
  content: NestedAccordionItem["content"] | NestedAccordionItem[];
};

export type AccordionGroupProps = PropsWithOptionalTestID & {
  items: AccordionItem[];
};

function AccordionGroup(props: AccordionGroupProps) {
  const { items, testID = "accordion-group" } = props;

  return (
    <S.Container allowsMultipleExpanded data-testid={testID}>
      {items.map((item) => {
        if (Array.isArray(item.content)) {
          return (
            <Accordion
              key={item.title}
              title={item.title}
              content={<NestedAccordionGroup items={item.content} />}
            />
          );
        }

        return <Accordion key={item.title} {...item} content={item.content} />;
      })}
    </S.Container>
  );
}

type NestedAccordionGroupProps = {
  items: NestedAccordionItem[];
};

function NestedAccordionGroup(props: NestedAccordionGroupProps) {
  const { items } = props;

  return (
    <S.NestedContainer allowsMultipleExpanded>
      {items.map((item) => (
        <Accordion key={item.title} {...item} variant="nested" />
      ))}
    </S.NestedContainer>
  );
}

export default AccordionGroup;
